var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30567",
    "data-name": "Path 30567",
    d: "M10.755.75a.755.755,0,0,1,.755.755V2.578a.755.755,0,1,1-1.509,0V1.5A.755.755,0,0,1,10.755.75ZM3.679,3.679a.755.755,0,0,1,1.067,0l.756.756A.755.755,0,0,1,4.436,5.5l-.756-.756A.755.755,0,0,1,3.679,3.679Zm14.14,0a.755.755,0,0,1,0,1.067l-.755.756A.755.755,0,0,1,16,4.436l.755-.756A.755.755,0,0,1,17.819,3.679ZM6.552,6.552a5.936,5.936,0,1,1-1.739,4.2A5.937,5.937,0,0,1,6.552,6.552Zm4.2-.229a4.427,4.427,0,1,0,1.694.337A4.427,4.427,0,0,0,10.75,6.323Zm-10,4.432A.755.755,0,0,1,1.5,10H2.578a.755.755,0,1,1,0,1.509H1.5A.755.755,0,0,1,.75,10.755Zm17.428,0A.755.755,0,0,1,18.932,10H20a.755.755,0,1,1,0,1.509H18.932A.755.755,0,0,1,18.178,10.755ZM5.5,16a.755.755,0,0,1,0,1.067l-.757.757a.755.755,0,0,1-1.067-1.067L4.437,16A.755.755,0,0,1,5.5,16ZM16,16a.755.755,0,0,1,1.067,0l.757.757a.755.755,0,0,1-1.067,1.067L16,17.063A.755.755,0,0,1,16,16Zm-5.241,2.182a.755.755,0,0,1,.755.755V20A.755.755,0,1,1,10,20V18.932A.755.755,0,0,1,10.755,18.178Z",
    transform: "translate(-0.75 -0.75)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIcon);
export default __webpack_public_path__ + "static/media/sunIcon.fc8cf22e76526ce2dbe3c9a5b227d566.svg";
export { ForwardRef as ReactComponent };